import { Box, Chip, Tooltip, Typography } from '@mui/material';
import CopyToClipboardButton from 'components/CopyToClipboardButton/CopyToClipboardButton';

interface ProjectFilterCellProps {
  projectIds: string[];
  projectNamesById: Map<string, string>;
  projectsLoaded: boolean;
}

export default function ProjectFilterCell({ projectIds, projectNamesById, projectsLoaded }: ProjectFilterCellProps) {
  if (!projectIds.length) return 'All';

  return (
    <Tooltip
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 'none',
            bgcolor: 'background.paper',
            color: 'text.primary',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 3,
          },
        },
      }}
      title={
        <Box sx={{ display: 'flex', flexDirection: 'column', py: 0.5 }}>
          {projectIds.map((id) => {
            const name = projectNamesById.get(id);
            const unresolved = !name && projectsLoaded;
            return (
              <Box key={id} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography variant="body2" component="span" sx={{ whiteSpace: 'nowrap' }}>
                  {name ? (
                    <>
                      {name}{' '}
                      <Box component="span" sx={{ fontFamily: 'monospace', color: 'text.secondary' }}>
                        ({id})
                      </Box>
                    </>
                  ) : unresolved ? (
                    <>
                      <Box component="span" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                        No access or deleted
                      </Box>{' '}
                      <Box component="span" sx={{ fontFamily: 'monospace', color: 'text.secondary' }}>
                        ({id})
                      </Box>
                    </>
                  ) : (
                    <Box component="span" sx={{ fontFamily: 'monospace' }}>
                      {id}
                    </Box>
                  )}
                </Typography>
                <CopyToClipboardButton data={id} size="small" subject="ID" />
              </Box>
            );
          })}
        </Box>
      }
    >
      <Chip
        label={`${projectIds.length} project${projectIds.length > 1 ? 's' : ''}`}
        size="small"
        role="button"
        tabIndex={0}
      />
    </Tooltip>
  );
}
